import axios from 'axios';

const flagAppointment = async ({
  appointmentId,
  flagged,
}: {
  appointmentId: string;
  flagged: boolean;
}) => {
  await axios.post(`/appointments/${appointmentId}/flag`, {
    flagged,
  });
};

export default flagAppointment;
